import { useQuery } from "@tanstack/react-query";
import { AdminApi } from "../../api/services";
import { PageHeader, Spinner } from "../../components/common";
import { DataTable } from "../../components/DataTable";
import { dateTime } from "../../lib/format";

export default function AdminAudit() {
  const { data, isLoading } = useQuery({ queryKey: ["admin", "audit"], queryFn: AdminApi.audit });
  if (isLoading) return <Spinner />;
  return (
    <div>
      <PageHeader title="Audit logs" subtitle="Latest 200 security-relevant actions." />
      <DataTable testId="audit-table" rows={data || []} columns={[
        { key: "at", label: "When", render: (a) => dateTime(a.at) },
        { key: "actor", label: "Actor", render: (a) => <span>{a.actor_email}<span className="block text-xs text-slate-500">{a.actor_role}</span></span> },
        { key: "action", label: "Action", render: (a) => <span className="font-mono text-xs">{a.action}</span> },
        { key: "target", label: "Target", render: (a) => <span className="font-mono text-xs text-slate-500">{a.target?.slice(0, 12)}</span> },
        { key: "details", label: "Details", render: (a) => <span className="text-xs text-slate-500">{Object.keys(a.details || {}).length ? JSON.stringify(a.details) : ""}</span> },
      ]} />
    </div>
  );
}
